import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { TRANSLATION_NAMESPACE } from './constants';
// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
    ns: TRANSLATION_NAMESPACE,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
        prefix: '[',
        suffix: ']',
    },
});

export default i18n;
